import ApiRequest from '@/plugins/axios'

export default {
  getList () {
    return ApiRequest.get('queue?dontExtendSession=1').then((response) => response.entries)
  },
  clearErrors () {
    return ApiRequest.get('queue/clearErrors')
  }
}
